
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { otherRules } from '@/utils/rules'
@Component({
  name: 'GoogleAndAuditDialog'
})
export default class extends Vue {
  @Prop({required: true}) private authCode!: string
  @Prop({default: true}) private isGoogle!: boolean

  private infoForm: any = {
    google_code: '',
    description: null
  }
  private rules = otherRules
  private back(is: boolean) {
    if (is) {
      (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          this.$emit('back', this.infoForm)
        } else {
          return
        }
      })
    } else {
      this.$emit('back', null)
    }
  }
  created() {
    
  }
}
